// extracted by mini-css-extract-plugin
export default {"container":"Title_container__Vg4Ly","title":"Title_title__KL1V+","description":"Title_description__nJH1c"};